module.exports = __webpack_public_path__ + "static/img/screening.75de290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screening.png
// module id = 1351
// module chunks = 1